export function hasPermission(
  permissions: string[] | null | undefined,
  permissionCode: string
): boolean {
  return Array.isArray(permissions) && permissions.includes(permissionCode)
}

/**
 * @param role Rol del usuario (p. ej. desde el login). Opcional: si se omite, no se aplican excepciones por rol.
 */
export function hasPermissionOrAllowLegacy(
  permissions: string[] | null | undefined,
  permissionCode: string,
  role?: string | null
): boolean {
  if (!Array.isArray(permissions) || permissions.length === 0) return true
  if (permissions.includes(permissionCode)) return true
  // Permisos nuevos (p. ej. tras migración): la sesión guardada puede no listarlos hasta nuevo login.
  const r = role?.trim().toUpperCase()
  if (
    permissionCode === 'initialSetup.access' &&
    (r === 'SUPER_ADMIN' || r === 'ADMIN')
  ) {
    return true
  }
  return false
}
